import dayjs from 'dayjs';
import { IProductOrder } from 'app/shared/model/product-order.model';
import { ServiceStatus } from 'app/shared/model/enumerations/service-status.model';

export interface IServiceOrder {
  id?: number;
  startDate?: dayjs.Dayjs | null;
  endDate?: dayjs.Dayjs | null;
  serviceStatus?: keyof typeof ServiceStatus | null;
  createdTimestamp?: dayjs.Dayjs | null;
  productOrder?: IProductOrder | null;
}

export const defaultValue: Readonly<IServiceOrder> = {};
